// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"f8492c7f","734":"f8492c7f"}[chunkId] + ".chunk.css";
};